export default {
  产品行业分类: 'Industry',
  产品标题: 'Product Name',
  产品副标题: 'Product subtitle',
  产品品牌: 'Brand Name',
  产品轮播图: 'Product Photos',
  产品视频: 'Product Video',
  产品3D超链接: 'Hyperlink to 3D Product Display',
  产品规格: 'Product Specifications',
  单价币种: 'Currency of Unit Price',
  服务与承诺: 'Service and Commitment',
  产品详情: 'Product Details',
  // 产品行业分类: 'Industry',
  // 产品副标题: 'Product subtitle',
  // 产品品牌: 'Brand Name',
  // 产品轮播图: 'Product Photos',
  // 产品3D超链接: 'Hyperlink to 3D Product Display',
  // 单价币种: 'Currency of Unit Price',
  // 产品详情: 'Product Details',
  产品浏览密码: 'Product viewing password',
  '若产品需要针对竞争对手保密,防止泄露相关产品详细信息,可设置一组4位纯数字的密码,输入正确的密码才可以查看':
    'If the product needs to be kept confidential from competitors to prevent the disclosure of related product details, you can set a 4-Arabic numeral password and enter the correct password to view',
  '不设置(任何人都可以查看)': 'No setting (Anyone can view it)',
  '设置(输入密码才可以查看)': 'Setting (Enter the password to view)',
  产品规格与库存: 'Product specifications and inventory',
  '禁止发布涉及政治、色情、暴力、低俗等违法不良信息, 一经发现封号并报警处理!':
    'It is prohibited to publish illegal or inappropriate information involving politics, or containing pornography, violence, vulgarity, and etc. Once discovered, the user will be suspended and will be reported to the police.',
  请输入产品标题: 'Please enter the product title',
  请输入产品副标题: 'Please enter the product subtitle',
  请输入产品品牌: 'Please enter the product brand',
  请选择行业分类: 'Please select the industry the event is about.',
  '可描述产品的一些特有功能、亮点等广告用词':
    'The subheading can be concise description of the product’s features, functions and so on.',
  '建议上传正方形图片,大小10M以内': 'JPG/PNG formats are accepted. Maximum file size: 10M',
  '数量限制在10张以内,仅支持JPG/PNG格式,至少上传1张':
    'Preferably square pictures. Please upload at least one and no more than ten pictures.',
  点击上传: 'Click to Upload',
  '建议上传时长60秒以内/宽高比为1:1或16:9或3:4,大小不超过100M':
    'Preferable duration: within 60 seconds. Aspect ratio 1:1 or 16:9 or 3:4. Maximum file size: 100M.',
  点击上传视频: 'Click to Upload Video',
  '若有3D展示,则输入产品3D超链接': 'If there is a 3D display, enter the product 3D hyperlink',
  '若价格为面议,请在单价填【0】': 'If the price is negotiable, please enter [0] in Unit Price.',
  '起售数量,指的客户意向采购下单的最低默认数量,具体采购的产品数量建议与客户沟通交流,签订合同':
    "The starting quantity refers to the minimum default quantity of the customer's intention to purchase. It is suggested to communicate with the customer and sign the contract for the specific quantity of the purchased goods",
  '预览图,指的是该产品不同规格的图片,图片建议500*500px,不大于5M':
    'Preview image refers to the pictures of different specifications of the product. It is suggested that the pictures should be 500 * 500px, no more than 5m',
  '单位,指的是该产品的规格,如台、瓶、张、个、㎡、Kg、g等':
    'Unit refers to the specification of the commodity, such as table, bottle, sheet, piece, square meter, kg, G, etc',
  '单价,指的是该产品规格下,该单位下的销售价格,单价最高可设99999999.99':
    'Unit price refers to the sales price of the unit under the commodity specification. The maximum unit price can be set as 9999999.99',
  '起拍数量,指的是需要达到所设置的起拍数量才可以采购下单':
    'Minimum Order Quantity is the lowest amount of products that the supplier is willing to sell each time.',
  // '单位,指的是该产品的规格,如台、瓶、张、个、㎡、Kg、g等':
  //   'Unit refers to the single unit of measurement of a product, such as piece, square meter, kilogram, gram, and etc.',
  // '预览图,指的是该产品不同规格的图片,图片建议500*500px,不大于5M':
  //   'The preview image refers to the image of the product with different specifications. The image is recommended to be 500*500px, not larger than 5M',
  '单价,指的是该产品规格下,该单位下的销售价格':
    'Preview is the photo of a product variant. Recommended image resolution: 500*500px. Maximum file size: 5M.',
  请选择币种: 'Please select currency',
  '产品规格效果预览（示例）': 'Product Specifications Preview (Example)',
  'kpaad值换购....': 'kpaad value redemption...',
  '200元/罐': '¥200',
  '89894罐可售': '89894',
  '1罐起拍': '1 can start',
  添加规格: 'Add Variant',
  预览图: 'Preview',
  产品规格名称: 'Product Variant',
  单位: 'Unit',
  单价: 'Unit Price',
  起拍数量: 'Minimum Order Quantity',
  请填写: 'Please fill out this field.',
  删除: 'Delete',
  是否预售: 'Availability',
  发货时间承诺: 'Shipment',
  售后承诺: 'After-Sales Service',
  '上传产品图片时,为了达到更好的展示效果,建议产品详情页图片统一宽度,且图片宽度不超过1000px,若有文字描述,建议排版统一字体与大小':
    'In order to leave a better first impression on your potential buyers, it is recommended that all product photos are of the same width and below 1000px. If there is a text description, it will be better to have your text contents displayed in a uniform format.',
  操作: 'Action',
  '产品行业分类不能为空！': 'Commodity industry category cannot be empty!',
  '产品标题不能为空！': 'Product title cannot be empty!',
  最多填写50个汉字: 'Characters Limit: 100',
  '产品品牌不能为空！': 'The product brand cannot be empty!',
  '产品轮播图不能为空！': 'The merchandise carousel picture cannot be empty!',
  '请选择产品浏览权限！': 'Please select product browsing permissions!',
  请输入4位纯数字浏览密码: 'Please enter 4  Arabic numeral passwords',
  '最多120个字符,汉字、字符、字母均按1个字符数计算':
    'Up to 120 characters can be input, Chinese characters, characters, and letters are counted as 1 character',
  '因参展商的设置,您需要输入产品访问密码才可以浏览':
    'Due to the exhibitor’s setting, you need to enter the product access password',
  '币种不能为空！': 'Currency cannot be empty!',
  '产品3D链接最多填写300个汉字！': 'Fill in up to 300 characters for the product 3D link!',
  请输入产品详情: 'Please enter product details',
  '您的编辑还未保存, 是否离开?': 'Your edit has not been saved, do you want to leave?',
  请编辑产品详情: 'Please edit product details',
  规格预览图: 'Preview',
  规格名称: 'Preview',
  采购时间: 'Submission Date',
  请输入规格名称: 'Please enter Variation',
  请输入单位: 'Unit',
  '请输入单价,只可以输入数字': 'Please enter Unit Price Numb0ers.',
  请输入起拍数量: 'Please enter Minimum Order Quantity',
  请上传预览图: 'Click to upload image',
  '规格名称,不可为空,最多可输入30个字符': 'Character Limit: 60',
  '单位,最多可输入8个字符': 'Character Limit: 16',
  '编码,最多可输入20个字符': 'Character Limit: 40',
  请添加规格: 'Add Variant',
  '产品SKU,至少输入一条规格数据': 'Please enter at least one product SKU',
  请填写产品详情介绍: 'Please enter product details',
  '提交产品信息成功,请等待审核': 'Submit product information successfully, please wait for review',
  '请删除已上传的视频,再重新添加': 'Please delete the uploaded video and add it again',
  只能上传mp4格式文件: 'Only MP4 format is accepted.',
}
